var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumber2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 121,
    viewBox: "0 0 67 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.8649 41.435C64.8649 41.3202 64.1379 43.1569 64.1379 43.1569C60.7131 50.3891 55.5664 57.4873 51.1659 63.4758C46.8802 69.3495 42.5945 75.1085 38.194 80.8674C33.6595 86.8751 29.1251 92.8636 24.6098 98.986L13.2259 113.68H64.4057V120.3H0.119995L19.3483 94.949C23.8827 88.9605 28.532 82.9529 33.0664 76.9452C37.3521 71.1863 41.7527 65.4274 46.0384 59.5536C50.3241 53.6799 55.1072 46.9452 58.7807 39.3495C59.393 37.0154 59.8904 34.5664 59.8904 31.8878C59.8904 17.921 48.87 6.9197 34.9032 6.9197C20.9363 6.9197 9.9159 17.9401 9.9159 33.1123H3.42994C3.42994 14.6302 17.7603 0.299805 34.9032 0.299805C52.046 0.299805 66.3764 14.745 66.3764 31.8878C66.3764 35.1978 65.8789 38.5077 64.9032 41.435H64.8649Z",
    fill: "#231F20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber2);
export default __webpack_public_path__ + "static/media/NUMBER_2.afc07ec55f7baa4584b7e9eb772fccef.svg";
export { ForwardRef as ReactComponent };